// Bascule le fond et l'ombre du header selon la position de défilement.
// En haut de page : transparent. Au-delà du seuil : fond black-haze-50 + ombre.
//
// La barre d'avis (#header-topbar) a été retirée du header : la logique qui
// mesurait sa hauteur pour translater le header, ainsi que l'animation des
// étoiles, ont été supprimées avec elle.

export function initHeaderScroll(root = document, { threshold = '2rem' } = {}) {
  const header = root.querySelector('#site-header');
  const mobilePanel = root.querySelector('#mobile-menu-panel');
  if (!header && !mobilePanel) return;

  const shadowClass = 'shadow-[1rem_0px_1rem_rgba(35,58,124,0.15)]';

  const toPx = (t) => {
    if (typeof t === 'number') return t;
    if (typeof t === 'string' && t.endsWith('rem')) {
      const n = parseFloat(t);
      const base = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      return n * base;
    }
    return parseFloat(t) || 32; // repli
  };

  const thresholdPx = toPx(threshold);

  const update = () => {
    const scrolled = window.scrollY >= thresholdPx;

    if (header) {
      header.classList.toggle('bg-transparent', !scrolled);
      header.classList.toggle('bg-black-haze-50', scrolled);
      if (scrolled) header.classList.add(shadowClass);
      else header.classList.remove(shadowClass);
    }

    // Panneau mobile : arrondi complet en haut de page, coin bas seulement ensuite
    if (mobilePanel) {
      mobilePanel.classList.toggle('rounded-l-tiz', !scrolled);
      mobilePanel.classList.toggle('rounded-bl-tiz', scrolled);
    }
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
}
